export const basePath = '/world-health-org-metrics';
